/** Malay IPA overrides for words not in the dictionary. */
export const ma: Record<string, string> = {
  Abdul: 'abdul',
  bebas: 'bebas',
  boleh: 'boleh',
  gemawan: 'ɡəmawan',
  Hamid: 'hamid',
  ibni: 'ibni',
  Jebat: 'dʒəbat',
  Johor: 'dʒohoɾ',
  kebebasan: 'kəbebasan',
  Lekir: 'ləkiɾ',
  Lekiu: 'ləkiw',
  Malaysia: 'malejsia',
  merdeka: 'məɾdeka',
  mereka: 'məreka',
  Oleh: 'oleh',
  samarata: 'samarata',
  Sarawak: 'saɾawak',
  seekor: 'səekoɾ',
  seksaan: 'seksaʔan',
  Selangor: 'səlaŋoɾ',
  selendang: 'sələndaŋ',
  Singapura: 'siŋɡapuɾa',
  Terengganu: 'təɾeŋɡanu',
  Tuhan: 'tuhan',
};
